// src/pages/notfound.js
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./notfound.css";

function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <h2 className="notfound-subtitle">
          {t("notfound:page_not_found", "Page Not Found")}
        </h2>
        <p className="notfound-description">
          {t(
            "notfound:description",
            "Sorry, the page you are looking for does not exist."
          )}
        </p>
        <Link to="/" className="notfound-home-link">
          {t("notfound:back_to_home", "Back to Home")}
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
